import { QaAddendumConstants } from './qaAddendum.constants'
import { IQaAddendumAction, IQaAddendumState } from './qaAddendum.types'

const flagInitialState = {
  selectedFlagDetail: null,
  detailFlagId: null,
  chartSummary: null,
  chartSummaryFlagId: null,
  addendumText: '',
  reassignAssignee: null,
  reassignReason: '',
}

export const initialQaAddendumState: IQaAddendumState = {
  ...flagInitialState,
  selectedFlagId: null,
  isDetailLoading: false,
  isChartSummaryLoading: false,
  isSubmitting: false,
}

export function qaAddendumReducer(
  state: IQaAddendumState = initialQaAddendumState,
  action: IQaAddendumAction
): IQaAddendumState {
  switch (action.type) {
    case QaAddendumConstants.SET_FLAG_DETAIL:
      return {
        ...state,
        selectedFlagDetail: action.selectedFlagDetail ?? null,
        isDetailLoading: false,
      }
    case QaAddendumConstants.SET_CHART_SUMMARY:
      return {
        ...state,
        chartSummary: action.chartSummary ?? null,
        chartSummaryFlagId: action.chartSummaryFlagId ?? null,
        isChartSummaryLoading: false,
      }
    case QaAddendumConstants.SET_ADDENDUM_TEXT:
      return { ...state, addendumText: action.addendumText ?? '' }
    case QaAddendumConstants.SET_REASSIGN_ASSIGNEE:
      return { ...state, reassignAssignee: action.reassignAssignee ?? null }
    case QaAddendumConstants.SET_REASSIGN_REASON:
      return { ...state, reassignReason: action.reassignReason ?? '' }
    case QaAddendumConstants.RESET_REASSIGN:
      return { ...state, reassignAssignee: null, reassignReason: '' }
    case QaAddendumConstants.RESET_DRAFT_INPUTS:
      return { ...state, addendumText: '', reassignAssignee: null, reassignReason: '' }
    case QaAddendumConstants.SET_SELECTED_FLAG_ID: {
      const nextId = action.selectedFlagId ?? null
      if (nextId === state.selectedFlagId) return state
      return { ...state, ...flagInitialState, selectedFlagId: nextId }
    }
    case QaAddendumConstants.FETCH_QA_FLAG_DETAIL:
      return { ...state, isDetailLoading: true, detailFlagId: action.flagId ?? null }
    case QaAddendumConstants.FETCH_CHART_SUMMARY:
      return { ...state, isChartSummaryLoading: true }
    case QaAddendumConstants.SUBMIT_QA_FLAG_ADDENDUM:
      return { ...state, isSubmitting: true }
    case QaAddendumConstants.SET_SUBMITTING:
      return { ...state, isSubmitting: action.isSubmitting ?? false }
    case QaAddendumConstants.RESET_STATE:
      return initialQaAddendumState
    default:
      return state
  }
}
